import React from "react";
import "./Tax.css";

const Tax = () => {
  const taxProducts = [
    {
      id: 1,
      name: "Client Management for Tax Professionals",
      description: "Specialized CRM system designed for tax practitioners and accounting firms.",
      features: [
        "Client database management",
        "Document collection portal",
        "Tax organizer preparation",
        "Secure file sharing",
        "Billing and invoicing",
        "Tax deadline tracking"
      ],
      expectations: [
        "Streamlined tax season workflow",
        "Improved client communication",
        "Secure document exchange",
        "Reduced administrative tasks"
      ],
      customization: [
        "Firm branding",
        "Custom client portals",
        "Integration with tax software",
        "Workflow automation"
      ]
    },
    {
      id: 2,
      name: "Legal Client & Case Management",
      description: "Comprehensive practice management solution for law firms.",
      features: [
        "Case and matter management",
        "Time tracking and billing",
        "Document automation",
        "Conflict checking",
        "Court calendar integration",
        "Client communication tools"
      ],
      expectations: [
        "Increased billable hours",
        "Better case organization",
        "Improved client service",
        "Regulatory compliance"
      ],
      customization: [
        "Practice area templates",
        "Custom document workflows",
        "Trust accounting",
        "Mobile access"
      ]
    },
    {
      id: 3,
      name: "Tax Filing & Document Submission",
      description: "Secure platform for preparing and submitting tax documents.",
      features: [
        "Electronic tax form preparation",
        "Error checking",
        "E-filing capabilities",
        "Client signature collection",
        "Payment processing",
        "Document archiving"
      ],
      expectations: [
        "Faster filing process",
        "Reduced errors",
        "IRS compliance",
        "Audit-ready documentation"
      ],
      customization: [
        "State-specific forms",
        "Branded client portal",
        "Bulk processing",
        "API integrations"
      ]
    },
    {
      id: 4,
      name: "Appointment & Consultation Scheduler",
      description: "Professional scheduling system for tax and legal consultations.",
      features: [
        "Online booking",
        "Calendar synchronization",
        "Automated reminders",
        "Video conferencing",
        "Intake forms",
        "Payment collection"
      ],
      expectations: [
        "Reduced no-shows",
        "24/7 appointment availability",
        "Streamlined intake process",
        "Improved client satisfaction"
      ],
      customization: [
        "Service-specific scheduling",
        "Custom booking rules",
        "CRM integration",
        "Multi-language support"
      ]
    },
    {
      id: 5,
      name: "Document Storage & Compliance Tracker",
      description: "Secure document management with compliance monitoring.",
      features: [
        "Encrypted file storage",
        "Version control",
        "Access permissions",
        "Audit trails",
        "Retention policies",
        "Compliance reporting"
      ],
      expectations: [
        "Secure client data protection",
        "Easy document retrieval",
        "Regulatory compliance",
        "Reduced storage costs"
      ],
      customization: [
        "Custom metadata fields",
        "Workflow automation",
        "eSignature integration",
        "Client access portals"
      ]
    },
    {
      id: 6,
      name: "Contract & Agreement Builder",
      description: "Automated system for creating and managing legal contracts.",
      features: [
        "Template library",
        "Clause database",
        "Collaborative editing",
        "Approval workflows",
        "Electronic signatures",
        "Version history"
      ],
      expectations: [
        "Faster contract creation",
        "Reduced legal review time",
        "Standardized agreements",
        "Secure execution process"
      ],
      customization: [
        "Document type templates",
        "Company branding",
        "CRM integration",
        "AI-assisted drafting"
      ]
    }
  ];

  return (
    <div className="tax-container">
      <div className="tax-header">
        <h1>Tax & Legal Services</h1>
        <p className="subtitle">Specialized solutions for tax professionals and legal practitioners</p>
      </div>

      <div className="tax-grid">
        {taxProducts.map((product) => (
          <div key={product.id} className="tax-card">
            <div className="tax-card-header">
              <h2>{product.name}</h2>
              <p className="tax-card-description">{product.description}</p>
            </div>

            <div className="tax-card-details">
              <div className="tax-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="tax-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="tax-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* <div className="tax-card-footer">
              <button className="tax-demo-button">Request Demo</button>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tax;